define('drops/documentPreviewer/documentPreviewer',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util'
], function ($, lq, Drop, Style, util) {
    'use strict';

    var filenameEndsWith = function(filename, suffixes) {
        if (!filename) return false;
        return _.some(suffixes, function (suffix) {
            return filename.toLowerCase().indexOf(suffix, filename.length - suffix.length) !== -1;
        });
    };

    function DocumentPreviewer(options) {
        Drop.call(this, $('<div/>'), options);
        Style.renderStyles(this);
    }

    Drop.extend(DocumentPreviewer, Drop);

    DocumentPreviewer.typeName = 'DocumentPreviewer';

    DocumentPreviewer.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    DocumentPreviewer.prototype.setValue = function (update) {
        var valueObj = util.convertListOfKeyValuesToObject(update.value);
        var fileUrl = this.getFileUrl(update, valueObj);

        this.$element.empty();
        this.pendingPreviewLink = null;
        if (!fileUrl) return;

        var fileSrcUrl = this.getFullFileUrl(fileUrl);

        if (this.isImageFile(fileUrl)) {
            this.renderImage(fileSrcUrl);
        } else if (this.isVideoFile(fileUrl)) {
            this.renderVideo(fileSrcUrl);
        } else if (this.isPdfFile(fileUrl)) {
            this.renderFrame(this.getEmbeddedUrl(fileUrl, fileSrcUrl));
        } else {
            this.renderExternalViewer(fileUrl);
        }
    };

    // Office Online and Google fetch the file without the cookie of the user, so they get a signed link.
    DocumentPreviewer.prototype.renderExternalViewer = function (fileUrl) {
        var self = this;
        var pendingPreviewLink = this.pendingPreviewLink = this.piping.dispatcher
            .dispatch('DynamicContent/CreatePreviewLink', { url: fileUrl });

        pendingPreviewLink.then(function (link) {
            if (self.pendingPreviewLink !== pendingPreviewLink) return;

            self.pendingPreviewLink = null;
            self.renderFrame(self.getEmbeddedUrl(fileUrl, self.getSignedFullFileUrl(fileUrl, link)));
        });
    };

    DocumentPreviewer.prototype.getFileUrl = function (update, valueObj) {
        if (!valueObj) return null;
        if ($.type(valueObj) === 'string') return valueObj;

        var v = update && update.value;
        return (v && (v.url || v.Url)) || null;
    };

    DocumentPreviewer.prototype.clearValue = function () {
        this.pendingPreviewLink = null;
        this.$element.empty();
    };

    DocumentPreviewer.prototype.renderImage = function (href) {
        this.$element.append(
            $('<img/>', { src: href }).css({
                display: 'block',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                margin: '0 auto'
            })
        );
    };

    DocumentPreviewer.prototype.renderVideo = function (href) {
        this.$element.append(
            $('<video/>', {
                src: href,
                controls: true
            }).css({
                display: 'block',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                margin: '0 auto'
            })
        );
    };

    DocumentPreviewer.prototype.renderFrame = function (href) {
        this.$element.append(
            $('<iframe/>', {
                src: href,
                width: '100%',
                height: '100%',
                frameborder: 0
            })
        );
    };

    DocumentPreviewer.prototype.getEmbeddedUrl = function (documentUrl, fullDocumentUrl) {

        if (this.isOfficeFile(documentUrl))
            return 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fullDocumentUrl);

        if (this.isPdfFile(documentUrl))
            return lq.getCdnUrl('drops/DocumentPreviewer/view/viewer.html?file=' + encodeURIComponent(fullDocumentUrl) + '&bust=v2023');

        return 'https://docs.google.com/viewer?url=' + encodeURIComponent(fullDocumentUrl) + '&embedded=true';
    };

    DocumentPreviewer.prototype.getFullFileUrl = function (fileUrl) {
        return lq.getFullUrl(lq.getTenantUrl('DynamicContent/DownloadFile?url=' + fileUrl + '&openInBrowser=true'));
    };

    DocumentPreviewer.prototype.getSignedFullFileUrl = function (fileUrl, link) {
        var fullFileUrl = this.getFullFileUrl(fileUrl);

        if (!link || !link.signature)
            return fullFileUrl;

        return fullFileUrl + '&expires=' + link.expires + '&signature=' + encodeURIComponent(link.signature);
    };

    DocumentPreviewer.prototype.isPdfFile = function (filename) {
        return filenameEndsWith(filename, ['.pdf']);
    };

    DocumentPreviewer.prototype.isOfficeFile = function (filename) {
        return filenameEndsWith(filename, ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']);
    };

    DocumentPreviewer.prototype.isImageFile = function (filename) {
        return filenameEndsWith(filename, ['.bmp', '.jpg', '.jpeg', '.png', '.gif']);
    };

    DocumentPreviewer.prototype.isVideoFile = function (filename) {
        return filenameEndsWith(filename, ['.avi', '.flv', '.m4v', '.mov', '.mp4', '.mpeg', '.mpg', '.ogv', '.webm', '.wmv']);
    };

    return DocumentPreviewer;
});
